import { useEffect, useState } from 'react';
import { Navigate, Link, useNavigate } from 'react-router'
import { useAuth } from '../../../contexts/authContext'
import { doCreateUserWithEmailAndPassword } from '../../../firebase/auth'
import { Row } from 'react-bootstrap'
import { updateProfile } from "firebase/auth";
import { Events } from '../../../firebase/telemetry'

const Register = () => {

    const navigate = useNavigate()

    const [email, setEmail] = useState('')
    const [fullName, setFullName] = useState('')

    const [password, setPassword] = useState('')
    const [confirmPassword, setconfirmPassword] = useState('')
    const [isRegistering, setIsRegistering] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const [passwordMatch, setPasswordMatch] = useState(true);
    const [acceptedlegalshit, setAcceptedLegalShit] = useState(false);

    useEffect(() => {
        if (password === confirmPassword) {
            setPasswordMatch(true);
        } else if (password !== confirmPassword) {
            setPasswordMatch(false)
        }

    }, [password, confirmPassword])
    const { userLoggedIn } = useAuth()

    const onSubmit = async (e) => {
        e.preventDefault()
        if (!isRegistering) {
            setIsRegistering(true)
            Events.signUpStart()
            await doCreateUserWithEmailAndPassword(email, password)
                .then((result) => {
                    Events.signUpDone()
                    return updateProfile(result.user, {
                        displayName: fullName, photoURL: ""
                    })
                }).catch(error => {
                    Events.signUpFailed(error?.code)
                    setIsRegistering(false)

                    alert(error)
                });
        }
    }

    return (
        <>
            {userLoggedIn && (<Navigate to={'/'} replace={true} />)}
            <div style={{ height: '100vh' }} className='d-flex align-items-center py-4 bg-body-tertiary'>
                <main class="form-signin w-100 m-auto">
                    <form
                        onSubmit={onSubmit}
                    >
                        <Row>
                            <img class="mb-4" src="https://map.goldfinder.net.au/noBgColor.png" alt="" />
                        </Row>
                        <Row className='text-center'>
                            <h3 className="mb-4">Create a New Account</h3>

                        </Row>

                        <div class="form-floating mb-2">
                            <input
                                className="form-control"
                                type="text"
                                autoComplete='text'
                                required
                                placeholder="name@example.com"
                                id="floatingInput"
                                value={fullName}
                                onChange={(e) => { setFullName(e.target.value) }}
                            />
                            <label for="floatingInput">Full Name</label>
                        </div>
                        <div class="form-floating mb-2">
                            <input
                                className="form-control"
                                type="email"
                                autoComplete='email'
                                required
                                placeholder="name@example.com"
                                id="floatingInput"
                                value={email}
                                onChange={(e) => { setEmail(e.target.value) }}
                            />


                            <label for="floatingInput">Email address</label>
                        </div>
                        <div class="form-floating">
                            <input
                                type="password"
                                autoComplete='current-password'
                                required
                                value={password} onChange={(e) => { setPassword(e.target.value) }}
                                className={`form-control ${passwordMatch ? "" : "is-invalid"}`}
                                id="floatingPassword"
                                placeholder="Password"
                            />

                            <label for="floatingPassword">Password</label>

                            <div id="floatingPassword" class="invalid-feedback">
                                Passwords Don't Match
                            </div>
                        </div>
                        <div class="form-floating">
                            <input
                                type="password"
                                autoComplete='current-password'
                                required
                                value={confirmPassword} onChange={(e) => { setconfirmPassword(e.target.value) }}
                                className={`form-control ${passwordMatch ? "" : "is-invalid"}`}
                                id="floatingPassword"
                                placeholder="Confirm Password"
                            />

                            <label for="floatingPassword">Confirm Password</label>

                            <div id="floatingPassword" class="invalid-feedback">
                                Passwords Don't Match
                            </div>
                        </div>

                        <div class=" form-check">
                            <input className={`form-check-input ${acceptedlegalshit ? "" : "is-invalid"}`} type="checkbox" value={acceptedlegalshit} onChange={() => { setAcceptedLegalShit(!acceptedlegalshit) }} id="flexCheckDefault" />
                            <label className="form-check-label" for="flexCheckDefault">
                                I Agree to the Goldfinder <a target="_blank" href='/terms'> Terms & Conditions </a> and <a target="_blank" href='/privacy'>Privacy Policy</a>
                            </label>
                            <div id="flexCheckDefault" class="invalid-feedback">
                            </div>
                        </div>



                        <button
                            type="submit"
                            disabled={isRegistering || !passwordMatch || !acceptedlegalshit || password === ''}
                            className={'btn btn-primary w-100 py-2'}
                        >
                            {isRegistering ? 'Signing Up...' : 'Sign Up'}
                        </button>


                        <div class="form-check text-start my-3">
                            Already have an account? {'   '}
                            <Link to={'/login'} className="text-center text-sm hover:underline font-bold">Login</Link>
                        </div>

                        <p class="mt-5 mb-3 text-body-secondary">&copy; 2025 GoldFinder</p>
                    </form>
                </main>
            </div>
        </>
    )
}

export default Register